<template>
  <dropdown
    :force-visibility="showDropdown"
    title="Email Notifications"
    placement="bottom"
    popper-min-width-size="extra-large"
    @open="onOpen"
  >
    <el-tooltip placement="top">
      <template #content>
        <div>Email notifications</div>
      </template>
      <i class="ddi ddi-email-notification" />
    </el-tooltip>
    <template #content>
      <div>
        <loading-placeholder v-if="isLoading" :lines="3" />
        <template v-else>
          <h5>
            Notify me by email when updates are made to...
          </h5>
          <ul>
            <li
              v-for="option in notificationInfo.listNotificationOptions" 
              :key="option.id"
              @click="updateNotificationOption(option.id)"
            >
              <i class="ddi ddi-email-notification" /><span :class="{'selected' : option.id===selectedNotificationOptionID}">{{option.name}}</span>
            </li>
          </ul>
        </template>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IProjectsOutputMyNotifications } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default defineComponent({
  name: 'EmailNotificationsPicker',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      showDropdown: false,
      notificationInfo: {} as IProjectsOutputMyNotifications,
      selectedNotificationOptionID: null as any,
    }
  },

  methods: {
    closeDropdown() {
      this.showDropdown = true
      this.$nextTick(() => {
        this.showDropdown = false
      })
    },
    async onOpen() {
      this.isLoading = true
      if (this.entityType === EEntities.MAILBOXES) {
        this.notificationInfo = await MailboxesAPI.get_MyNotifications(
          this.entityId,
        )
      } else {
        this.notificationInfo = await InternalProjectsAPI.get_MyNotifications(
          this.entityId,
        )
      }
      this.selectedNotificationOptionID = this.notificationInfo.notificationOptionID
      this.isLoading = false
    },
    async updateNotificationOption(id: number) {
      try {
        this.selectedNotificationOptionID = id
        let response
        if (this.entityType === EEntities.MAILBOXES) {
          response = await MailboxesAPI.post_MyNotifications(
            this.entityId,
            this.selectedNotificationOptionID,
          )
        } else {
          response = await InternalProjectsAPI.post_MyNotifications(
            this.entityId,
            this.selectedNotificationOptionID,
          )
        }
        this.$messaging.showSuccess(response.message)
        this.closeDropdown()
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
</script>
